module.exports = __webpack_public_path__ + "static/media/snappyFooter.5addb04a.svg";